import { takeEvery } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";

export const nutStatSlice = createSlice({
  name: "nutstat",
  initialState: {
    showTutorial: false,
  },
  reducers: {
    openTutorial: (state) => {
      state.showTutorial = true;
    },
    closeTutorial: (state) => {
      state.showTutorial = false;
    },
  },
});

export const { openTutorial, closeTutorial } = nutStatSlice.actions;

export default nutStatSlice.reducer;
